import { io } from 'socket.io-client';

let socket = null;

// Helper function to get API URL - handles both development and production
const getApiUrl = () => {
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const serverPort = process.env.REACT_APP_SERVER_PORT;
  
  if (!serverUrl) {
    return 'http://localhost:5000'; // fallback for development
  }

  let url = serverUrl;

  // If it's a production HTTPS URL or already includes a port, don't append port
  if (serverUrl.startsWith('https://') || serverUrl.includes(':')) {
    url = serverUrl;
  } else {
    // For development (HTTP without port), append the port
    if (serverPort) {
      url = `${serverUrl}:${serverPort}`;
    }
  }
  
  // Remove trailing slash to prevent double slashes when constructing endpoints
  return url.replace(/\/$/, '');
};

export const initializeSocket = () => {
  if (!socket) {
    const API_URL = getApiUrl();

    console.log('🔧 Initializing socket connection to:', API_URL);

    socket = io(API_URL, {
      autoConnect: false,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      maxReconnectionAttempts: 5,
      timeout: 20000,
      forceNew: false
    });

    socket.on('connect', () => {
      console.log('🔌 Connected to Socket.IO server:', socket.id);
    });

    socket.on('disconnect', (reason) => {
      console.log('🔌 Disconnected from Socket.IO server:', reason);
    });

    socket.on('connect_error', (error) => {
      console.error('🔌 Socket.IO connection error:', error);
    });

    socket.on('reconnect', (attemptNumber) => {
      console.log('🔌 Reconnected to Socket.IO server after', attemptNumber, 'attempts');
    });

    socket.on('reconnect_attempt', (attemptNumber) => {
      console.log('🔌 Attempting to reconnect... Attempt:', attemptNumber);
    });

    socket.on('reconnect_error', (error) => {
      console.error('🔌 Reconnection error:', error);
    });

    socket.on('reconnect_failed', () => {
      console.error('🔌 Failed to reconnect to Socket.IO server');
    });
  }
  
  return socket;
};

export const connectSocket = (userId = null) => {
  const socketInstance = initializeSocket();
  
  if (!socketInstance.connected) {
    console.log('🔌 Connecting socket...');
    socketInstance.connect();
  }
  
  // Join user-specific room if userId provided
  if (userId) {
    if (socketInstance.connected) {
      console.log('🏠 Joining user room:', userId);
      socketInstance.emit('join-user-room', userId);
    } else {
      // Wait for connection then join room
      socketInstance.once('connect', () => {
        console.log('🏠 Joining user room on connect:', userId);
        socketInstance.emit('join-user-room', userId);
      });
    }
  }
  
  return socketInstance;
};

export const disconnectSocket = () => {
  if (socket) {
    console.log('🔌 Disconnecting socket...');
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => {
  return socket;
}; 